import React from "react";
import Lottie from "lottie-react";
import LottieLoader from "../Images/loader.json";

const LottieAnimationLoader = ({props}) => <Lottie animationData={LottieLoader} loop={true} {...props} />;

export default LottieAnimationLoader;